import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';
import { UserRole } from '../models/auth.model';

export const isDirectorGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);

  return await authService.checkRolePermission(UserRole.director);
};
